import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Page} from '../../model/page';
import {Table} from 'primeng/table';
import {Observable} from 'rxjs/Observable';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-table',
    templateUrl: './app-table.component.html',
    styleUrls: ['./app-table.component.css'],
})
export class AppTableComponent implements OnInit {

    @ViewChild('table') masterDataTable: Table;
    @ViewChild('content') content: ElementRef;
    @ViewChild('tableHeader') tableHeader: ElementRef;
    @ViewChild('tableFilter') tableFilter: ElementRef;
    @ViewChild('paginator') paginator: ElementRef;

    @Input() dataService: Observable<IRest<any>>;
    @Input() page = new Page();
    @Input() size = 50;
    @Input() actionBarHeight = 0;
    @Input() masterHeight = 0;
    @Input() tableColumns;

    @Output() pageEvent = new EventEmitter<Page>();

    public loading = false;
    public scrollHeight = '50px';

    rows = new Array<any>();

    constructor(private toastr: ToastrService) {
        this.page.pageNumber = 0;
        this.page.size = this.size;
    }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.loading = true;
        this.pageEvent.emit(this.page);
        this.dataService.subscribe(result => {
                this.page.totalElements = result._meta.totalCount;
                this.page.totalPages = result._meta.totalCount / this.page.size;
                this.rows = result.data.slice();
                this.loading = false;

                setTimeout(() => {
                    this.scrollHeight = this.getScrollHeight() + 'px';
                }, 100);

            },
            error => {
                console.log(error);
                this.loading = false;
                this.toastr.error('Data loading error occured', 'Service Error', {
                    timeOut: 3000,
                });
            });
    }

    getScrollHeight(): number {
        return (this.masterHeight) -
            this.actionBarHeight - (this.tableHeader.nativeElement.offsetHeight +
                this.tableFilter.nativeElement.offsetHeight + this.paginator.nativeElement.offsetHeight);
    }

    onPage(event) {
        if (this.page.totalElements < this.page.size) {
            return;
        }
        this.page.pageNumber = (event.first / event.rows);
        this.page.size = event.rows;
        this.loadData();
    }

    buttonPress(e) {
        if (e.keyCode === 13) {
            this.filterChanged();
        }
    }

    filterChanged() {
        setTimeout(() => {
            this.page.pageNumber = 0;
            this.masterDataTable.first = 0;
            this.loadData();
        }, 100);
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/app-table/app-table.component.ts